import { MenuItem, MenuItemProps } from "@mui/material";

export function ContextMenuItem(props: MenuItemProps) {
    return (
        <MenuItem
            {...props}
            sx={{
                fontSize: 14,
                py: "3px",
                ...props.sx,
            }}
        />
    );
}